import React, { createContext, useState } from 'react';
import manager from './Manager';

// Buat konteks baru
export const AppContext = createContext();

// Buat provider komponen untuk menyediakan state global ke komponen-komponen anak
export const AppContextProvider = ({ children }) => {

  const [globalState, setGlobalState] = useState({
    selectedIndex:0,
    slides: manager.slides,
    progressData: manager.progressData,
    settings: manager.settings,
    values: {},
  });
  // Definisikan fungsi untuk memperbarui state global
  const updateGlobalState = (key, value) => {
    setGlobalState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  // Menyediakan state global dan fungsi pembaruan ke komponen-komponen anak
  return (
    <AppContext.Provider value={{ globalState, updateGlobalState }}>
      {children}
    </AppContext.Provider>
  );
};
